export default __webpack_public_path__ + "static/media/aampower.524b2b15.png";